module.exports = __webpack_public_path__ + "img/credit.cf026f49.svg";